class DebtRequest {
  agencyid = null;
  amount = 0;
  usedamount = 0;
  startdatetime = null;
  enddatetime = null;

  createdby = null;
  updatedby = null;

  constructor() {}
}

export default DebtRequest;
